<template>
  <div>
    <view-table
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="incomings"
        :span-merge-keys="['deliveryNo','supplierName','supplierNo','checkStatusName','inspectorName','billNo', 'selection', 'action']"
        :table-select="false"
        @addOrEdit="addEditHandle"
        @delete="deleteHandle"
        @reset="resetHandle">
      <template slot="otherBtn"/>
      <template slot="adSearch">
        <el-form label-width="80px" :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="质检日期">
            <el-date-picker
                v-model="createTime"
                :picker-options="pickerOptions"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']"
                @change="createTimeChange"/>
          </el-form-item>
          <el-form-item label="质检状态">
            <el-select v-model="filter.checkStatus" clearable>
              <el-option label="未质检" :value="0"/>
              <el-option label="已质检" :value="1"/>
              <el-option label="已入库" :value="2"/>
              <el-option label="所有" :value="-1"/>
            </el-select>
          </el-form-item>
          <el-form-item label="送货单号">
            <el-input v-model.trim="filter.deliveryNo" placeholder="请输入送货单号" clearable/>
          </el-form-item>
          <el-form-item label="物料号">
            <el-input v-model.trim="filter.materialNo" placeholder="请输入物料号" clearable/>
          </el-form-item>
          <el-form-item label="编号">
            <el-input v-model.trim="filter.billNo" placeholder="请输入编号" clearable/>
          </el-form-item>
          <el-form-item label="供应商">
            <el-input v-model.trim="filter.supplierName" placeholder="请输入供应商" clearable/>
          </el-form-item>
          <el-form-item label="客户名称">
            <el-input v-model.trim="filter.customerName" placeholder="请输入客户名称" clearable/>
          </el-form-item>
          <el-form-item label="凭证号">
            <el-input v-model.trim="filter.voucherNo" placeholder="请输入凭证号" clearable/>
          </el-form-item>
          <el-form-item label="出厂编号">
            <el-input v-model.trim="filter.factoryNo" placeholder="请输入出厂编号" clearable/>
          </el-form-item>
          <el-form-item label="采购订单号">
            <el-input v-model.trim="filter.purchaseOrderNo" placeholder="请输入采购订单号" clearable/>
          </el-form-item>
        </el-form>
      </template>
      <!--      <template slot="actionBtn" slot-scope="scope">-->
      <!--        <el-button-->
      <!--            type="primary"-->
      <!--            :loading="submitLoading"-->
      <!--            @click="submitHandle(scope.row)">-->
      <!--          提交-->
      <!--        </el-button>-->
      <!--      </template>-->
    </view-table>
    <inspection-incoming-edit ref="incomingEdit" @save-success="loadData"/>
  </div>
</template>
<script>
  import constant from "../../../util/constant";
  import constants from "@/util/constants";
  import ViewTable from "@/components/ViewTable";
  import InspectionIncomingEdit from "@/views/inspection/inspectionIncoming/InspectionIncomingEdit";

  export default {
    name:"InspectionIncomingList",
    components: {InspectionIncomingEdit, ViewTable},
    data() {
      return {
        limits: {
          addAuth: this.$auth(569),
          editAuth: this.$auth(570),
        },
        pickerOptions: {
          shortcuts: [{
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          }, {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          }, {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          }],
        },
        createTime: "",
        constant,
        constants,
        reportStatus: constant.toSelect(constant.reportStatus, "addAll"),
        columnsProperty: [
          {
            key: "billNo",
            align: "center",
            width: 160,
            tooltip:true,
            render: (h, params) => {
              return h(
                  "span",
                  {
                    style: {
                      color: "#2d8cf0",
                      cursor: "pointer",
                    },
                    on: {
                      click: () => {
                        this.$router.push({
                          path: "/InspectionIncomingPreview",
                          query: {
                            billType: 23,
                            billId: params.row.pkid,
                            $tabName: params.row.billNo,
                          },
                        });
                      },
                    },
                  },
                  params.row.billNo,
              );
            },
          },
          {
            key: "deliveryNo",
            align: "center",
            width: 160,
            tooltip: true,
          },
          {
            key: "checkStatusName",
            align: "center",
            width: 100,
            tooltip: true,
          },
          {
            key: "inspectorName",
            align: "center",
            width: 100,
            tooltip: true,
          },
          {
            key: "no",
            align: "center",
            width: 180,
            tooltip: true,
          },
          {
            key: "materialNo",
            align: "center",
            width: 160,
            tooltip: true,
          },
          {
            key: "mappingMaterialNo",
            align: "center",
            width: 100,
            tooltip: true,
          },
          {
            key: "materialName",
            align: "center",
            width: 260,
            tooltip: true,
          },
          {
            key: "purchaseOrderNo",
            align: "center",
            width: 130,
            tooltip: true,
          },
          {
            key: "purchaseOrderRowNo",
            align: "center",
            width: 80,
            tooltip: true,
          },
          {
            key: "factoryNo",
            align: "center",
            width: 100,
            tooltip: true,
          },
          {
            key: "submissionNum",
            align: "center",
            width: 90,
            tooltip: true,
          },
          {
            key: "spotCheckNum",
            align: "center",
            width: 90,
            tooltip: true,
          },
          {
            key: "unqualifiedNum",
            align: "center",
            width: 120,
            tooltip: true,
          },
          {
            key: "badQuality",
            align: "center",
            width: 90,
            tooltip: true,
          },
          {
            key: "inspectionResult",
            align: "center",
            width: 200,
            tooltip:true,
            render: (h, params) => {
              return h(
                  "el-switch",
                  {
                    props: {
                      value: params.row.inspectionResult,
                      disabled: true,
                      activeColor: "#13ce66",
                      inactiveColor: "#ff4949",
                      activeText: "ok",
                      inactiveText: "ng",
                    },
                  },
              );
            },
          },
          {
            key: "creatorName",
            align: "center",
            width: 120,
            tooltip: true,
          },
          {
            key: "creatTime",
            align: "center",
            width: 160,
            tooltip: true,
          },
          {
            key: "action",
            align: "center",
            width: 140,
            slot: "action",
            fixed: "right",
          },
        ],
        show: "",
        exportLoading: false,
        exportLoading1: false,
        submitLoading: false,
        filter: {
          filter: "",
          beginCreateTime: "",
          endCreateTime: "",
          voucherNo: "",
          purchaseOrderNo: "",
          factoryNo: "",
          checkStatus: 0,
          deliveryNo: "",
          materialNo: "",
          inspectorName: "",
          inspectionReportNo: "",
          billNo: "",
          supplierName: "",
          customerName: "",
          inspectionResult: 0,
        },
        details: [],
      };
    },
    methods: {
      addEditHandle(row) {
        console.log(row);
        this.$refs.incomingEdit.open(row);
      },
      createTimeChange(date) {
        if (date !== null) {
          this.filter.beginCreateTime = date[0];
          this.filter.endCreateTime = date[1];
        } else {
          this.filter.beginCreateTime = "";
          this.filter.endCreateTime = "";
        }
      },

      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },


      submitHandle(row) {
        this.$confirm("确定提交吗?", "提示", {type: "warning"}).then(() => {
          this.submitLoading = true;
          this.$http.get("basic", `incomings/submit/${row.pkid}`).then((resp) => {
            if (resp.success) {
              this.$message.success("提交成功");
              this.submitLoading = false;
              this.loadData();
            }
          });
        });
      },

      deleteHandle(row) {
        this.$http.delete("basic", "incomings", row.pkid).then((resp) => {
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },
      selectHandle(selection) {
        this.selection = selection;
      },

      resetHandle(filter) {
        this.filter = filter;
      },
    },
    mounted() {
      // const originalSureExport = this.$refs.viewTable.sureExport;
      this.$refs.viewTable.sureExport = () => {
        this.$refs.viewTable.exportLoading = true;
        let params = Object.assign({ pageNum: 1, pageSize: this.$refs.viewTable.model.exportNum }, this.filter);
        this.$http
          .exportExcel("basic", "incomings/export", params, this.$refs.viewTable.model.exportFields.join())
          .then((res) => {
            const blob = new Blob([res.data]);
            const downloadElement = document.createElement("a");
            const href = window.URL.createObjectURL(blob);
            const contentDisposition = res.headers["content-disposition"];
            const fileName = decodeURI(contentDisposition.split("filename*=utf-8''")[1].split(".")[0]);
            downloadElement.style.display = "none";
            downloadElement.href = href;
            downloadElement.download = fileName + ".xls";
            document.body.appendChild(downloadElement);
            downloadElement.click();
            document.body.removeChild(downloadElement);
            window.URL.revokeObjectURL(href);
            this.$refs.viewTable.exportVisible = false;
            this.$refs.viewTable.exportLoading = false;
          })
          .catch(() => {
            this.$refs.viewTable.exportVisible = false;
          });
      };
    },
  };
</script>
<style lang="scss" scoped>
::v-deep .ivu-table-expanded-cell {
  padding: 0;
  padding-right: 140px;
}
</style>
